export class PostHog {
  capture() {}
  shutdown() {
    return Promise.resolve()
  }
}
